// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubProfileCard-cls1___5d1e8f1a05bb289a761","cls2":"ImpactHubProfileCard-cls2___60e9092691a679fb7c6 ImpactHubProfileCard-cls1___5d1e8f1a05bb289a761"};